var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModule5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 52,
    viewBox: "0 0 62 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0756 15.4455C40.144 16.0071 37.9388 16.9327 35.4264 18.3016L42.0756 15.4455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7474 41.1043C57.736 44.574 67.4378 33.7391 54.6888 26.8703C55.5407 20.8507 49.1399 13.3915 42.0756 15.4455M42.0756 15.4455C40.144 16.0071 37.9388 16.9327 35.4264 18.3016L42.0756 15.4455ZM42.0756 15.4455C38.1908 -3.01414 11.8473 -4.43061 11.4191 18.9389C1.50813 19.5762 -5.99794 35.7223 12.7651 41.1043",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4414 41.4582C25.042 41.4582 40.4701 41.4582 41.377 41.4582C45.2717 41.2794 45.5382 34.0876 39.3064 36.283",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0156 45.4002C28.6163 45.4002 35.3921 45.4002 36.299 45.4002C40.1938 45.579 40.4603 52.7708 34.2285 50.5754",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1484 36.4582C29.7491 36.4582 32.4712 36.4582 33.3781 36.4582C37.2729 36.2794 37.5394 29.0876 31.3076 31.283",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule5);
export default __webpack_public_path__ + "static/media/module5.9e66cbebb07a77f4354869bdae2d2ebd.svg";
export { ForwardRef as ReactComponent };